import {
  GET_USER_DATA_REQUEST,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_SIGN_OUT,
  USER_UPDATE_REQUEST,
  USER_UPDATE_FAILURE,
  USER_SET_DATA,
  USER_TOKEN_LOGIN_REQUEST,
} from './constants';
import { action } from './index';
import { User } from '../reducers/user';

export interface SignInRequest {
  email: string;
  password: string;
}

export const signInRequest = (payload: SignInRequest) => {
  return action(USER_LOGIN_REQUEST, payload);
};

export interface TokenSignInRequest {
  token: string;
}

export const tokenLoginRequest = (payload: TokenSignInRequest) => {
  return action(USER_TOKEN_LOGIN_REQUEST, payload);
};

export const signInSuccess = () => {
  return action(USER_LOGIN_SUCCESS);
};

export const setUserData = (user: User) => {
  return action(USER_SET_DATA, user);
};

export const userSignInError = () => {
  return action(USER_LOGIN_FAILURE);
};

export const signOutUser = () => {
  return action(USER_SIGN_OUT);
};

export const userUpdateRequest = (user: Partial<User>) => {
  return action(USER_UPDATE_REQUEST, user);
};

export const userUpdateFailure = () => {
  return action(USER_UPDATE_FAILURE);
};

export const getUserDataRequest = () => {
  return action(GET_USER_DATA_REQUEST);
};

export type UserActions = ReturnType<
  | typeof signInRequest
  | typeof signInSuccess
  | typeof setUserData
  | typeof userSignInError
  | typeof signOutUser
  | typeof userUpdateRequest
  | typeof userUpdateFailure
>;
